@if (form) {
  <div class="row">
    <div class="col-12">
      <p><span [innerHTML]="form.question_name"></span> @if (form.question_required) {
        <span class="required">*</span>
      }</p>
      <textarea rows="5" [readonly]="form.view" cols="30" pInputTextarea [autoResize]="true"
        [value]="form.answer_value || ''" placeholder="กรอกข้อความ" (input)="updateValue(val)"
      #val></textarea>
      <!-- <app-validate-items [action]="form.question_required" [valid]="form.answer_value"
      (validUpdate)="updateValiDate($event)">
      <textarea rows="5" [readonly]="form.view" cols="30" pInputTextarea [autoResize]="true"
        [value]="form.answer_value || ''" placeholder="Enter a description..." (input)="updateValue(val)"
      #val></textarea>
    </app-validate-items> -->
  </div>
</div>
}